import { showErrorToast } from "../../../configurator/renderer/tools/helper";
import { useUiTranslator } from "../../../hooks/useUiTranslator";
import { usePostApiEasyRedirectToEasy } from "../../../openapi/backendApi";
import { ErrorType } from "../../CustomCartIdRouteComponent/CustomCartIdRouteComponent";
import { cartStore } from "../../CustomCartIdRouteComponent/storeCart";

import { useState } from "react";
import { JSX } from "react";

import { VMLineItems } from "@4pace-cpq/core";
import { Button, CircularProgress } from "@mui/material";
import { useStore } from "@tanstack/react-store";

type EasyError = {
  applicationProductId: string;
  exceptionMessage: string;
};

type JmpToEasyErrorBody = {
  returnUrl: "";
  returnLocation: "";
  cpqErrorList: {
    [key: string]: string;
  };
  easyErrorList: EasyError[];
};

export const BtnJumpToEasy = ({
  lineItems,
  setErrorList,
  disabled,
}: {
  disabled: boolean;
  lineItems?: VMLineItems[] | null;
  setErrorList: (error: ErrorType[]) => void;
}): JSX.Element => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const t = useUiTranslator();
  const selectedItems = useStore(
    cartStore,
    (state): string[] => state["selectedItems"],
  );

  const { mutate: redirectToEasy } = usePostApiEasyRedirectToEasy();

  const handleClick = async (): Promise<boolean> => {
    setIsLoading(true);

    const updateSelectedItems = lineItems
      ?.filter((item) => selectedItems?.includes(item.id))
      .map((item) => item.id);

    redirectToEasy(
      { data: { lineItems: [...(updateSelectedItems ?? [])] } },
      {
        onSuccess: (response) => {
          setIsLoading(false);
          const responseData = response.data;

          if (
            responseData?.returnUrl &&
            typeof responseData?.returnUrl === "string"
          ) {
            window.location.href = responseData.returnUrl;
          } else {
            console.error(
              "Missing or invalid returnUrl in response data!",
              responseData,
            );
          }
        },
        onError: (error) => {
          setIsLoading(false);
          console.log("redirectToEasy error", error);
          const errorBody = error.info as JmpToEasyErrorBody | undefined;
          console.error(errorBody);
          if (error.status === 409) {
            setErrorList(errorBody?.easyErrorList ?? []);
            if (errorBody?.cpqErrorList) {
              Object.entries(errorBody.cpqErrorList).forEach(([key, value]) => {
                showErrorToast(t(`CustomApp:${key}`, value));
              });
            } else {
              showErrorToast(
                t(
                  "CustomApp:toast.JmpToEasy.genericError",
                  "Easy Endpoint error. Please try again.",
                ),
              );
            }
          } else if (error.status === 504) {
            showErrorToast(
              t(
                "CustomApp:toast.JmpToEasy.timeout",
                "Easy Endpoint time-out. Please try again",
              ),
            );
          } else {
            showErrorToast(
              t(
                "CustomApp:toast.JmpToEasy.genericError",
                "Easy Endpoint error. Please try again.",
              ),
            );
          }
        },
      },
    );

    return true;
  };

  return (
    <>
      <Button
        variant="contained"
        size="small"
        onClick={handleClick}
        disabled={disabled}
      >
        {isLoading ? (
          <CircularProgress size={"1em"} sx={{ mr: ".25em" }} />
        ) : null}
        {t("CustomApp:btn.loginToEasy", "Return to EASY")}
      </Button>
    </>
  );
};
